import SwiperCore, { Navigation, Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import { Card } from "react-bulma-components";
import styled from "styled-components";
import { useContext } from "react";
import StateContext from "../context/StateContext";
import Cloudy, { Warped } from "../effects/Cloudy";

SwiperCore.use([Navigation, Autoplay, Pagination]);

const StyledCard = styled(Card)`
  position: absolute;
  bottom: 5%;
  left: 4%;
  width: 60%;
  opacity: 0.9;
  background-color: ${(props) => props.theme.componentBackground};
`;

function CarouselCard(props) {
  return (
    <StyledCard>
      <Card.Header>
        <Card.Header.Title pt="2" pb="2">
          {props.title}
        </Card.Header.Title>
      </Card.Header>
      <Card.Content pb="0" pr="1">
        <div className="content" style={{ lineHeight: "normal" }}>
          {props.content}
        </div>
      </Card.Content>
      <Card.Footer style={{ border: "0" }}>
        <Card.Footer.Item
          href={props.buttonLink}
          pt="1"
          pb="1"
          textColor="light"
        >
          {props.buttonText}
        </Card.Footer.Item>
      </Card.Footer>
    </StyledCard>
  );
}

const StyledSlideSection = styled.section`
  background-image: url(${(props) => process.env.PUBLIC_URL + props.url});
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 0;
  padding-top: 31.25%;
`;

function CloudySlideSection({ cfg, ...props }) {
  return (
    <StyledSlideSection className="hero" url={cfg.backgroundImage}>
      {cfg.title && (
        <CarouselCard
          title={cfg.title}
          content={cfg.content}
          // buttonText={cfg.buttonText}
          buttonLink={cfg.buttonLink}
        ></CarouselCard>
      )}
    </StyledSlideSection>
  );
}

function Carousel({ carouselConfig, ...props }) {
  const [state] = useContext(StateContext);
  return (
    <Cloudy
      id="carouselfilter"
      opacity={(Math.tanh((state.numPagesVisited - 20) / 10) + 1) / 1.5}
    >
      <Swiper
        slidesPerView={1}
        navigation
        pagination={{ type: "bullets", clickable: true }}
        autoplay={{ delay: 3000 }}
        centeredSlides="true"
      >
        {carouselConfig.map((cfg, index) => (
          <SwiperSlide key={index}>
            <CloudySlideSection
              cfg={cfg}
              progress={state.numPagesVisited}
            ></CloudySlideSection>
          </SwiperSlide>
        ))}
      </Swiper>
    </Cloudy>
  );
}

export default Carousel;
